import { Pipe, PipeTransform } from '@angular/core';
import { GrowthSignalAgentDashboardListDto, GrowthSignalsCombinedSummaryResponseDto, GrowthSignalsMonthlyExportSummaryResponseDto, GrowthSignalsMonthlySummaryResponseDto } from 'src/app/shared/dto';

@Pipe({
  name: 'growthSignalsViewAllDisabled',
  standalone: true,
})
export class GrowthSignalsViewAllDisabledPipe implements PipeTransform {
  transform(
    agent: GrowthSignalAgentDashboardListDto | null | undefined,
    reportSummary: GrowthSignalsCombinedSummaryResponseDto | GrowthSignalsMonthlySummaryResponseDto | GrowthSignalsMonthlyExportSummaryResponseDto | null | undefined,
  ): boolean {
    if (!agent || !reportSummary) {
      return !agent ? true : false;
    }

    const weeklySummary = reportSummary.weekly_summary || [];
    const total = weeklySummary.reduce(
      (sum, entry) => sum + (entry.total_company_count || 0) + (entry.total_contact_count || 0) + (entry.all_companies_count || 0),
      0,
    );

    return total === 0;
  }
}
